export default {
  home: {
    title: 'Accueil',
    explanation: 'Retour à l\'accueil',
    tab1: 'Base Artl@s',
    tab2: 'Données',
    tab3: 'Utilisation',
    tab4: 'Navigation',
    tab1_title1: 'Bienvenue dans la base Artl@s !',
    tab1_par1: 'Artl@s met à votre disposition BasArt, une base numérique mondiale de catalogues d’expositions. Elle est destinée à contenir tous types de catalogues d’exposition, de l’invention du catalogue (Salon de Paris, 1673) jusqu’à nos jours.',
    tab1_par2: 'Cette base est géoréférencée et datée. Elle permet de cartographier les expositions, de retracer la circulation des oeuvres et les expositions des artistes. Elle permet aussi, lorsque cette information est disponible, de relier les oeuvres exposées à leurs lieux de localisation, leurs propriétaires, au lieu de naissance de leur auteur, et à tous autres types d’information renseignée d’après les catalogues.',
    tab1_par3: 'Depuis 2019 la base est maintenue et augmentée par les équipes de la chaire des Humanités numériques de l’',
    tab1_link0: 'université de Genève',
    tab1_par3a: '. La construction de la base a été financée par l’',
    tab1_link1: 'Agence nationale pour la Recherche',
    tab1_par4: ' (ANR), grâce à un projet Jeunes Chercheurs–Jeunes Chercheuses (2011-2016). Son développement et son entretien ont été permis jusqu’en 2019 grâce au soutien de l’',
    tab1_link2: 'École normale supérieure',
    tab1_par5: ', de l’',
    tab1_link3: 'Université de recherche Paris Sciences Lettres',
    tab1_par6: ' et du ',
    tab1_link4: 'labex TransferS',
    tab1_par7: ' (École normale supérieure - Collège de France, Paris).',
    tab1_par8: 'Le contenu de la base est apporté bénévolement par plus d’une centaine de chercheurs actifs partout dans le monde. Ils donnent de leur temps et leur expertise pour mettre à disposition de tous des données géoréférencées, souvent difficiles d’accès. La base Artl@s doit aider à élargir les horizons de l’histoire de l’art aussi bien du côté de la sociologie (faire place au grand nombre) que d’un point de vue géographique (faire place aux “périphéries”).',
    tab1_title2: 'Direction du Projet : Béatrice Joyeux-Prunel, Université de Genève, Chaire des Humanités numériques.',
    tab1_par9: 'En collaboration avec Catherine Dossin (Purdue University) et Nicola Carboni (University of Illinois).',
    tab1_par10: 'Structure de la base de données :',
    tab1_par11: 'Interface :',
    tab2_title1: 'Que contient la base Artlas ?',
    tab2_par1: 'Nous axons depuis 2023 la collecte sur les catalogues des expositions suisses. Une précédente collecte a concerné les Biennales. Ces sources doivent aider à sortir de la géopolitique monocentrique et bilatérale qui a longtemps caractérisé l’histoire de l’art des 19e et 20e siècles (Paris-New-York).',
    tab2_par2: 'La base doit permettre aussi d’étudier de manière globale le collectionnisme, la présence des femmes, l’évolution des sujets et des formes artistiques, l’institutionnalisation de l’art moderne et contemporain, l’histoire du marché, la politique dans les biennales etc… ainsi que les questions de centres et de périphéries dans l’histoire mondiale de l’art vivant.',
    tab2_title2: 'Sources',
    tab2_par3: 'BasArt est un travail collaboratif. Elle est en constante augmentation, à mesure que les chercheur-se-s y ajoutent de nouvelles expositions et de nouveaux catalogues.',
    tab2_par4: 'Les informations ont été insérées dans la base Artl@s en respectant rigoureusement le catalogue d’origine. Si, par exemple, la date de naissance des exposants n’est pas renseignée par le catalogue, elle ne sera pas ajoutée par les contributeurs d’Artl@s. De plus, le nom d’un même artiste peut donc apparaître de différentes façons selon l’exposition, par exemple “Matisse (Henri)” ou “Henri-Matisse”. Les recherches dans la base Artl@s doivent tenir compte de cette marge d’incertitude.',
    tab2_par5: 'BasArt ne permet un point de vue exhaustif que lorsqu’une requête et/ou une visualisation porte(nt) sur des collections complètes, c’est à dire sur des catalogues complets, et en connaissance claire du nombre et de l’identité des catalogues pris en compte. La plupart des expositions répertoriées dans la base, en effet, ne sont pas encore reliées au catalogue qui en décrit les exposants : soit le catalogue n’existe pas, soit il n’a pas été trouvé; soit qu’il n’a pas encore été introduit dans la base.',
    tab3_title1: 'Conditions d’utilisation',
    tab3_par1: 'BasArt est mise gracieusement à disposition des publics par ses auteurs, quelle que soit l’utilisation des données.',
    tab3_par2: 'De même, les cartes et les graphiques réalisés à partir des collections de la base Artl@s sont à disposition de leurs utilisateurs.',
    tab3_par3: 'L’utilisateur s’engage à citer le projet et ses contributeurs à chaque utilisation.',
    tab3_title2: 'Citation',
    tab3_par4: 'Les modalités de citation sont les suivantes :',
    tab3_par5: 'pour un catalogue et son contenu :',
    tab3_par6: 'Exposition et catalogue renseignés par …[nom du contributeur]. BasArt, The Artl@s Project, dir. Béatrice Joyeux-Prunel, université de Genève.',
    tab3_par7: 'pour une carte et un graphique :',
    tab3_par8: '© BasArt, The Artl@s Project, dir. Béatrice Joyeux-Prunel, université de Genève.',
    tab3_par9: 'Le projet ARTL@S n’est pas responsable de la manière dont l’utilisateur utilisera les données, ni des conclusions qu’il en tirera.',
    tab4_par1: 'L’interface de recherche permet d’interroger les informations relatives aux expositions, et celles qui ont été copiées dans les catalogues d’expositions. Afin d’assurer une utilisation optimale, BasArt permet d’interroger sa liste d’expositions d’une part, et d’autre part le contenu des catalogues qui y sont répertoriés – soit trois types d’objets : les expositions, et (d’après les catalogues) les exposants et les oeuvres exposées.',
    tab4_title1: 'La recherche simple',
    tab4_par2: 'permet à l’utilisateur de naviguer parmi les expositions, les exposants ou les oeuvres exposées, en restreignant – on non – la recherche à certaines collections d’expositions, comme les biennales contenues dans la base.',
    tab4_title2: 'La recherche avancée',
    tab4_par3: 'donne la possibilité de croiser les requêtes sur les expositions, les exposants',
    tab4_par4: 'et/ou',
    tab4_par5: 'les oeuvres.',
    tab4_title3: 'Affichage des résultats',
    tab4_par6: 'L’utilisateur peut afficher le résultat des recherches selon',
    tab4_par7: 'trois modes de visualisation',
    tab4_par8: 'Une liste',
    tab4_par9: ', à gauche, dont les données peuvent être triés par date, ville d’exposition et titre.',
    tab4_par10: 'Une carte',
    tab4_par11: ', modulable chronologiquement grâce à une timeline en bas à droite.',
    tab4_par12: 'En cliquant sur la ville des fenêtres pop-up permettent de détailler les résultats de la requête.',
    tab4_par13: 'Un graphique',
    tab4_par14: ' quantitatif et temporel qui apparaît en cliquant sur le bouton de droite.'
  },
  results: {
    search: 'Recherche',
    of: 'de',
    in: 'dans',
    list: 'Liste',
    map: 'Carte',
    graph: 'Graphique',
    exportCsv: 'Exporter en CSV',
    firstname: 'Prénom',
    year: 'Année',
    title: 'Titre',
    titleUnknown: '[titre non indiqué]',
    city: 'Ville',
    unknown: 'Non renseigné',
    exhibition: 'Exposition',
    exhibitionTitle: 'Titre de l\'exposition',
    exhibitionYear: 'Année de l\'exposition',
    exhibitionCity: 'Ville de l\'exposition',
    exhibitedWorkTitle: 'Titre de l\'œuvre',
    gender: 'Sexe',
    biography: 'Éléments biographiques',
    nationality: 'Nationalité',
    birth: 'Naissance',
    birthSpace: 'Lieu de naissance',
    birthDate: 'Date de naissance',
    death: 'Décès',
    deathSpace: 'Lieu de décès',
    deathDate: 'Date de décès',
    catalogDates: 'Dates du catalogue',
    catalogUnknown: 'Catalogue non renseigné',
    address: 'Adresse',
    notes: 'Notes',
    exhibitedSpace: 'Lieu d\'exposition',
    exhibitedWork: 'Œuvre exposée',
    exhibitedWorks: 'Œuvres exposées',
    category: 'Catégorie',
    section: 'Section',
    sectionTitle: 'Titre de la section',
    sectionAddress: 'Adresse de la section',
    noSection: 'Titre de section non renseigné',
    creationDate: 'Date de création',
    creationDate2: 'Date de création 2',
    creationSpace: 'Lieu de céation',
    contributorUnknown: '[Contributeur non renseigné].',
    size: 'Taille',
    medium: 'Medium',
    room: 'Salle',
    credits: '© Artl@s, Ecole normale supérieure-PSL et Université de Genève, sous la direction de Béatrice Joyeux-Prunel.',
    filledBy: 'Données renseignées par',
    sources: 'Sources',
    sourceExhibition: 'Source de l\'exposition',
    owner: 'Propriétaire',
    exhibitedWorkNotReproduceInCatalog: 'Œuvre non reproduite au catalogue',
    exhibitedWorkReproducedInCatalog: 'Œuvre reproduite au catalogue.',
    price: 'Prix',
    exhibitors: 'Exposants',
    catalogTitle: 'Titre, ville, année d\'édition du catalogue',
    publicationDate: 'Date de publication',
    title_lower: 'Titre de l\'exposition ou du catalogue',
    begin_year: 'Année de début de l\'exposition',
    end_year: 'Année de fin de l\'exposition',
    country: 'Pays actuel',
    former_country: 'Pays de l\'époque',
    city_lower: 'Ville',
    traveling: 'Itinérante',
    source_catalog_lower: 'Source du catalogue',
    catalog_language_lower: 'Langue du catalogue',
    contributor_lower: 'Auteurs / Contributeurs au catalogue',
    notes_lower: 'Notes du contributeur à la base Artl@s',
    name: 'Nom',
    name_lower: 'Nom',
    nameMissing: 'Nom manquant',
    first_name: 'Prénom',
    first_name_lower: 'Prénom',
    name_firstname: 'Nom, Prénom',
    nationality_lower: 'Nationalité',
    city_b_lower: 'Ville de naissance',
    country_b: 'Pays de naissance',
    year_b: 'Date de naissance',
    year_d: 'Date de décès',
    exhibitor_name: 'Nom de l\'artiste',
    exhibitor_name_lower: 'Nom de l\'artiste',
    exhibitor_first_name: 'Prénom de l\'artiste',
    exhibitor_first_name_lower: 'Prénom de l\'artiste',
    year_c1: 'Année de conception',
    year_c2: 'Année de conception (fin)',
    city_c_lower: 'Ville de conception',
    country_c: 'Pays de conception',
    is_reproduced_in_catalog: 'Reproduction dans le catalogue',
    space_lower: 'Salle d\'exposition',
    owner_lower: 'Propriétaire',
    city_o_lower: 'Ville du propriétaire',
    country_o: 'Pays du propriétaire',
    source: 'Source',
    x: 'Coord X',
    y: 'Coord Y',
    nb_exhibition_catalog: '',
    public: 'Public',
    exhibition_group: 'Groupe d\'exposition',
    exhibition_group_type: 'Type de groupe',
    contributor: 'Contributeur',
    membership: 'Adhésion',
    instructor: 'Instructeur',
    birth_address: 'Adresse de naissance',
    exhibition_title: 'Titre de l\'exposition',
    exhibition_title_lower: 'Titre de l\'exposition',
    exhibition_city: 'Ville d\'exposition',
    exhibition_city_lower: 'Ville d\'exposition',
    begin_date: 'Date de début',
    end_date: 'Date de fin',
    section_x: 'Coord X de section',
    section_y: 'Coord Y de section',
    death_address: 'Adresse de décès',
    country_d: 'Pays de décès',
    number: 'N° au catalogue',
    translation_title: 'Titre traduit',
    subtitle: 'Sous titre',
    section_title: 'Titre de section',
    section_link: 'Accéder au détail de la section',
    section_address: 'Adresse de section',
    space: 'Espace',
    catalog_chapter: 'Chapitre du catalogue'
  },
  chart: {
    export: 'Exporter',
    partResults: 'résultat partiel',
    periodResults: 'Période de résultats',
    exhibitionTitles: 'titres des expositions ',
    ofType: 'de type ',
    includes: ' contenant "{value}"',
    allExhibition: 'toutes les expositions',
    exhibitedWorkWith: 'titres des œuvres contenant "{value}"',
    allExhibitedWorks: 'toutes les œuvres',
    exhibitorsNameWith: 'nom des artistes contenant "{value}"',
    allExhibitors: 'tous les artistes',
    exhibitions: ' expositions',
    exhibitors: ' artistes',
    exhibitedWorks: ' œuvres',
    title: 'Répartition des résultats par année',
    advancedSearch: 'Recherche avancée',
    feltingPoints: 'Pas assez de points pour afficher un graphique.',
    extendSearch: 'Merci d\'étendre la période de recherche.'
  }
}



// WEBPACK FOOTER //
// ./src/lang/fr_FR/pages.js